import { ObjectValues } from '@lumapps/lumx/react';
import { GLOBAL } from '@lumapps/translations';

import { AI } from './keys';

export const AI_IN_CONTRACT_FEATURE_TOKEN = 'ai-in-contract';

/** Ai Detailed negative feedback */
export const AI_REASON_TYPES = {
    INCORRECT: 'incorrect',
    IRRELEVANT: 'irrelevant',
    OUTDATED: 'outdated',
} as const;

/** Feedback reasons */
export const FEEDBACK_REASONS: Record<ObjectValues<typeof AI_REASON_TYPES>, string> = {
    [AI_REASON_TYPES.INCORRECT]: AI.FEEDBACK_REASON_INCORRECT,
    [AI_REASON_TYPES.IRRELEVANT]: AI.FEEDBACK_REASON_IRRELEVANT,
    [AI_REASON_TYPES.OUTDATED]: GLOBAL.OUTDATED,
};

/** Maximum length allowed for feedbacks comment */
/** Maximum length allowed for feedback comment */
export const FEEDBACK_COMMENT_MAX_LENGTH = 500;
